export default "__VITE_ASSET__CVIvyocv__"